import {PlusCircle, XCircle} from "react-bootstrap-icons";
import React, {useContext, useState} from "react";
import {AutoTradeStatusEnum, IAutoTrade } from "predictagram-lib";
import {ManualTradeAddModal} from "./ManualTradeAddModal";
import {ManualTradeCloseModal} from "./ManualTradeCloseModal";
import {adminApiServiceCommon} from "../../../services/AdminApiService";
import { MessengerContext } from "components/common/messenger";

export const ManualAddClose:React.FunctionComponent<{trade:IAutoTrade,onClosed?:()=>void,onAdded?:()=>void}> = ({trade,onClosed,onAdded})=>{
  const msgrContext = useContext(MessengerContext);
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [showCloseModal, setShowCloseModal] = useState<boolean>(false);

  const [isAdding, setIsAdding] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const closeTrade = async () => {
    if (!trade) {
      msgrContext.setMessage({ body: 'Missing Trade. Nothing done.' });
      return;
    }
    const id = trade.id;
    setIsDeleting(true);
    try {
      const res = await adminApiServiceCommon.closeTrade(id);
      if (res) {
        msgrContext.setMessage({ body: `Closed #${id}` });
        if (onClosed) {
          onClosed()
        }
      } else {
        console.error(JSON.stringify(res, null, 2));
        throw Error(`unexpected error trying to close`);
      }
    } catch (error: any) {
      msgrContext.setMessage({ body: `${(error as Error).message}` });
    } finally {
      setIsDeleting(false);
      setShowCloseModal(false);
    }
  }

  const addTrade = async () => {
    if (!trade) {
      msgrContext.setMessage({ body: 'Missing Trade. Nothing done.' });
      return;
    }
    const id = trade.id;
    setIsAdding(true);
    try {
      const res = await adminApiServiceCommon.addTrade(id);
      if (res) {
        msgrContext.setMessage({ body: `Added #${res.id}` });
        if (onAdded) {
          onAdded();
        }
      } else {
        console.error(JSON.stringify(res, null, 2));
        throw Error(`unexpected error trying to add`);
      }
    } catch (error: any) {
      msgrContext.setMessage({ body: `${(error as Error).message}` });
    } finally {
      setIsAdding(false);
      setShowAddModal(false);
    }
  }

  const confirmAdd = () => {
    setShowAddModal(true);
  }

  const confirmClose = () => {
    setShowCloseModal(true);
  }

  return (<>
      <div className="d-flex gap-2">
        {trade.ibkr.openOrders.length > 0 && <button className="btn btn-primary text-13" onClick={confirmAdd}><PlusCircle title="Add Trade" /></button>}
        {trade.statusId === AutoTradeStatusEnum.ACTIVE &&
         <button className="btn text-13 bg-red text-white" onClick={confirmClose}><XCircle title="Close Trade" /></button>
        }
      </div>
      {trade && <ManualTradeAddModal
        show={showAddModal}
        handleClose={() => setShowAddModal(false)}
        title='Add Trade'
        onConfirm={addTrade}
        trade={trade}
        isSubmitting={isAdding}
      />}

      {trade && <ManualTradeCloseModal
        show={showCloseModal}
        handleClose={() => setShowCloseModal(false)}
        title='Close Trade'
        onConfirm={closeTrade}
        trade={trade}
        isSubmitting={isDeleting}
      />}
    </>
    )
}
